import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    // ------------------------------
    // PUBLIC LANDING LAYOUT
    // ------------------------------
    {
      path: '/',
      component: () => import('@/view/layout/Moon-Landing-Page-Layout'),
      children: [
        {
          path: '',
          name: 'landing-page',
          component: () => import('@/view/pages/moon/MoonLandingPageNew.vue'),
          meta: { title: 'Moon Program - Sign up | برنامج مون - الانضمام' }
        },
        {
          path: 'join',
          name: 'join',
          component: () => import('@/view/pages/moon/MoonJoinPage.vue'),
          meta: { title: 'Moon Program - Sign up | برنامج مون - الانضمام' }
        },
        {
          path: 'terms&conditions',
          name: 'terms&conditions',
          component: () => import('@/view/pages/moon/terms&condition.vue'),
          meta: { title: 'Moon Program - Sign up | برنامج مون - الانضمام' }
        },
      ],
    },

    // ------------------------------
    // AUTH LAYOUT (Login / Register)
    // ------------------------------
    {
      path: "/dashboard",
      component: () => import('@/view/pages/moon/Auth'),
      children: [
        {
          name: "login",
          path: "login",
          component: () => import('@/view/pages/moon/Login'),
          meta: { guest: true }
        },
        {
          name: "register",
          path: "register",
          component: () => import('@/view/pages/moon/Register'),
          meta: { guest: true }
        }
      ]
    },

    // ------------------------------
    // PROTECTED DASHBOARD
    // ------------------------------
    {
      path: "/dashboard",
      component: () => import("@/view/layout/Custom.vue"),
      meta: { requiresAuth: true },   // 🔒 PROTECTED
      children: [
        {
          path: "",
          name: "dashboard",
          component: () => import("@/view/pages/moon/Custom-dashboard.vue"),
          meta: { requiresAuth: true },
        }
      ]
    },

    // ------------------------------
    // PUBLIC LANDING PAGE
    // ------------------------------
    {
      path: '/landing',
      name: 'landing',
      component: () => import('@/view/pages/moon/Landing.vue'),
      meta: { title: 'Moon Program - Landing | برنامج القمر - الهبوط' },
    },

    // ------------------------------
    // 404
    // ------------------------------
    {
      path: '/404',
      name: '404',
      component: () => import('@/view/pages/error/Error-1.vue'),
    },

    // Wildcard redirect
    {
      path: '*',
      redirect: '/404',
    },
  ]
});


// ----------------------------------------------------
// 🔒 Global Navigation Guard
// ----------------------------------------------------
router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem("contact_id"); // check if logged in

  // Protected pages
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      return next({ name: "login" });
    }
  }

  // Prevent logged-in users from accessing login/register
  if (to.matched.some(record => record.meta.guest)) {
    if (isLoggedIn) {
      return next({ name: "dashboard" });
    }
  }

  next();
});

export default router;
